import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram, Youtube } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-primary-teal to-teal-800 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <img 
                src="/fertility-ayurveda-logo.png" 
                alt="Fertility Ayurveda Logo" 
                className="h-16 w-auto brightness-0 invert"
              />
            </Link>
            <p className="text-white/80">Natural fertility solutions through ancient Ayurvedic wisdom.</p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2 text-white/80">
              <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/fertility-panchakarma" className="hover:text-white transition-colors">Fertility Panchakarma</Link></li>
              <li><Link to="/fertility-nutrition" className="hover:text-white transition-colors">Fertility Nutrition</Link></li>
              <li><Link to="/prakriti-analysis" className="hover:text-white transition-colors">Prakriti Analysis</Link></li>
              <li><Link to="/success-stories" className="hover:text-white transition-colors">Success Stories</Link></li>
              <li><Link to="/about" className="hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Contact Info</h3>
            <ul className="space-y-3 text-white/80">
              <li className="flex items-start space-x-2">
                <MapPin className="w-5 h-5 mt-1 flex-shrink-0" />
                <span>Koramangala, Bangalore, Karnataka, India</span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="w-5 h-5 flex-shrink-0" />
                <a href="tel:+919845158507" className="hover:text-white transition-colors">+91 98451 58507</a>
              </li>
              <li className="flex items-center space-x-2">
                <Mail className="w-5 h-5 flex-shrink-0" />
                <a href="mailto:info@fertilityayurveda.com" className="hover:text-white transition-colors">info@fertilityayurveda.com</a>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Follow Us</h3>
            <div className="flex space-x-4 mb-6">
              <a 
                href="https://www.instagram.com/fertility.ayurveda" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-all"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="https://www.youtube.com/@shreshthaayurveda" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-all"
              >
                <Youtube className="w-5 h-5" />
              </a>
            </div>
            <p className="text-white/80 text-sm">
              Follow us on Instagram @fertility.ayurveda for fertility tips & live sessions
            </p>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/20 mt-8 pt-8 text-center text-white/60">
          <p>&copy; 2025 Fertility Ayurveda. All rights reserved.</p>
          <p className="text-sm mt-2">Shreshtha Ayurveda & Panchakarma Center</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;